interface QcStampProps {
  /** Main stamp line, e.g. `On file`. Rendered uppercase. */
  label: string;
  /** Smaller second line: real data (a timestamp) or the brand sub-line. */
  sub: string;
  /**
   * `qc` — the earned ink stamp: approved-green, rotated.
   * `logomark` — the same stamp shape straightened into the Autopostmate lockup.
   */
  variant?: 'qc' | 'logomark';
}

/**
 * The signature ink stamp (brand system §6). Two jobs only: marking a record as
 * cleared, and — straightened — serving as the logomark lockup. Do not sprinkle
 * it on unrelated UI; its power comes from meaning something specific.
 */
export function QcStamp({ label, sub, variant = 'qc' }: QcStampProps) {
  const className = variant === 'logomark' ? 'qc-stamp qc-stamp--logomark' : 'qc-stamp';

  return (
    <span className={className}>
      <span className="qc-stamp__label">{label}</span>
      <span className="qc-stamp__sub">{sub}</span>
    </span>
  );
}
